import CircularProgress from '@material-ui/core/CircularProgress';
import { useEffect } from 'react';
import { withRouter } from 'react-router';
import { Subscribe } from 'unstated';

import UserContainer from '~/containers/User';
import useOnboardingStatus from '~/hooks/account/useOnboardingStatus';
import { useHasLegacyPlan } from '~/hooks/account/usePlatformAccess';

import styles from './Gatekeeper.style';

function Gatekeeper(props) {
  const {
    classes,
    currentUserLoaded,
    currentAccountLoaded,
    history,
    needsToOnboard,
    noAccess,
  } = props;

  const hasLegacyPlan = useHasLegacyPlan();
  const { shouldOnboard, loading: onboardingLoading } = useOnboardingStatus();

  useEffect(() => {
    if (!currentAccountLoaded || onboardingLoading) {
      return;
    }

    if (noAccess) {
      if (history.location.pathname !== '/no-access') {
        history.push('/no-access');
        return;
      }
    } else if (history.location.pathname === '/no-access') {
      history.push('/');
      return;
    }

    // We probably want to cut everyone over soon, but until we are done
    // testing, let's not disrupt onboarding for legacy account users
    if (hasLegacyPlan) {
      if (needsToOnboard() && history.location.pathname !== '/welcome') {
        history.push('/welcome');
      }
    } else {
      if (
        shouldOnboard &&
        !history.location.pathname.startsWith('/onboarding/')
      ) {
        history.push('/onboarding/welcome');
      }
    }
  }, [
    currentAccountLoaded,
    noAccess,
    shouldOnboard,
    hasLegacyPlan,
    onboardingLoading,
  ]);

  if (currentUserLoaded && currentAccountLoaded && !onboardingLoading) {
    return true;
  }

  return (
    <div className={classes.root}>
      <CircularProgress />
    </div>
  );
}

Gatekeeper.propTypes = {
  history: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  noAccess: PropTypes.bool.isRequired,
  needsToOnboard: PropTypes.func.isRequired,
  currentAccountLoaded: PropTypes.bool.isRequired,
  currentUserLoaded: PropTypes.bool.isRequired,
};

const SubscribedGatekeeper = (props) => (
  <Subscribe to={[UserContainer]}>
    {(container) => (
      <Gatekeeper
        currentUserLoaded={container.currentUserLoaded()}
        currentAccountLoaded={container.currentAccountLoaded()}
        noAccess={container.hasNoAccess()}
        needsToOnboard={container.needsToOnboard}
        {...props}
      />
    )}
  </Subscribe>
);

// withRouter is important here because this component lives outside our normal switch statement.
// For example an update wont happen if a user clicks the browser back button
export default withRouter(withStyles(styles)(SubscribedGatekeeper));
